import axios from "./Constant.js";

export const getUserDetails = async (token, user) => {
  try {
    const response = await axios.get("/get_user_details", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        id: user,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getFY = async (token) => {
  try {
    const response = await axios.get("/get_FY", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const create_user = async (token, formData) => {
  try {
    const response = await axios.post("/create_user", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const getDistrict = async (token, role, user_id) => {
  try {
    const response = await axios.get("/get_district", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        role_id: role,
        id: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getBlock = async (token, data) => {
  try {
    const response = await axios.post("/get_blocks",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getGPbyBlock = async (token, data) => {
  try {
    const response = await axios.post("/get_gp_by_block",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const getQuarterbyFY = async (token, data) => {
  try {
    const response = await axios.post("/get_quarter_from_fy",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getPaymentData = async (token, data) => {
  try {
    const response = await axios.post("/get_payment_data",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const vendor_payment_data = async (token, data) => {
  try {
    const response = await axios.post("/get_vendor_payment_data", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const reject_vendor_payment = async (token, data) => {
  try {
    const response = await axios.post("/reject_vendor_payment", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
}
export const getVenderData = async (token, data) => {
  try {
    const response = await axios.post("/get_approved_vendor", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
}
export const approveVendor = async (token, data) => {
  try {
    const response = await axios.post("/approve_vendor", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
}
export const rejectVendor = async (token, data) => {
  try {
    const response = await axios.post("/reject_vendor", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
}
export const VoucherUpload = async (token, formData) => {
  try {
    const response = await axios.post("voucher_upload", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

export const getVendorAccountDetail = async(token, data) => {
  try{
    const response = await axios.post("/vendor_account_details", data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data; 
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getVendorDetail = async(token, data) => {
  try{
    const response = await axios.post("/get_vendor", data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data; 
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

// export const downloadPaymentFile = async(token, data) => {
//   try{
//     const response = await axios.post("/download_payment_file", data,{
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     })
//     return response.data;
//   } catch (error) {
//     console.error("Error - ", error);
//     throw error;
//   }
// };
export const deductionTaxRate = async(token, data) => {
  try{
    const res = {
      type : data
    }
    const response = await axios.post(`/get_deduction_tax_rate`,res,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getUserGpBlockDistrict = async (token, data) => {
  try {
    const response = await axios.post("/get_user_gp_block_dist", 
      data,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};


export const getHeads = async (token, data) => {
  try {
    const response = await axios.post("/get_heads", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching heads:", error);
    throw new Error("Failed to fetch heads. Please try again later.");
  }
};

export const changePassword = async (token, data) => {
  try {
    const response = await axios.post("/change_password", 
      data,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const updateProfile = async (token, data) => {
  try {
    const response = await axios.post("/update_profile", 
      data,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateNumber = async (token, data) => {
  try {
    const response = await axios.post("/update_mob_no", 
      data,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const userLogout = async () => {
  try {
    const response = await axios.post("/logout")
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
}

export const downloadPaymentFile = async (token, data) => {
  try {
    const response = await axios.post("/download_payment_file", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',  
    });
    return response;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const dscChecker = async (token, data) => {
  try {
    const response = await axios.get("/is_dsc_inserted", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        username: data,
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const validateDSC = async (token, username) => {
  try {
    const response = await axios.get("/validate_dsc", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        username: username,
      },
    });
    return response;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const dscSignature = async (token, data) => {
  try {
    const response = await axios.post("/dsc_pdf_sign",data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const registryEntry = async (token, data) => {
  try {
    const response = await axios.post("/get_checker_regitry_entry",data, {
      
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const createVendorPayment = async (token, data) => {
  try {
    const response = await axios.post("/create_vendor_payment", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const createVendor = async (token, formData) => {
  try {
    const response = await axios.post("/vendor_registration", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getVendorByAccount = async (token, data) => {
  try {
    const response = await axios.post("/get_vendor_detail", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const checkVendor = async (token, data) => {
  try {
    const response = await axios.post("/check_vendor", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const getMajorheads = async (token ) =>{
  try{
    const response = await axios.get("/get_expenduture_major_heads",{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getMinorheads = async (token,data ) =>{
  try{
    const response = await axios.post("/get_expend_minor_heads",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getWorkTypes = async(token) =>{

try { 
  const response = await axios.get('/get_work_type_name',{
    headers:{
      Authorization:`Bearer ${token}`
    }
  });
  return response.data;
  
} catch (error) {
    console.log("Error - ", error);
    throw error;
}
}
export const getMajorheadsForReceivable = async (token ) =>{
  try{
    const response = await axios.get("/get_receivable_major_heads",{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const getMinorheadsForReceivable = async (token,data ) =>{
  try{
    const response = await axios.post("/get_receivable_minor_heads",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export async function geTax(token) {
  const response = await axios.get('/get_tax_rates', {
    headers: {
      Authorization: `Bearer ${token}`, 
    },
  });
  return response.data;
}

export async function updateTaxRate(token, id, tax_rate) {
  const response = await axios.post('/update_tax_rates',{ id,tax_rate },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response;
}

export const updateVendorAccountDetail = async (token,data ) =>{
  try{
    const response = await axios.post("/update_vendor_account_detail",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }

}
export const approveVenderPayment = async (token,data ) =>{
  try{
    const response = await axios.post("/approve_vendor_payment",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const checkReceivableMinorID = async (token,data ) =>{
  try{
    const response = await axios.post("/check_rec_minor_id",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const checkPayableMinorID = async (token,data ) =>{
  try{
    const response = await axios.post("/check_pay_minor_id",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const addPayableMinorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/add_pay_minor_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const addReceivableMinorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/add_rec_minor_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const updateReceivableMinorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/update_rec_minor_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const updatePayableMinorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/update_pay_minor_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const updatePayableMajorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/update_pay_major_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const updateReceivableMajorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/update_rec_major_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const checkPayableMajorHeadId = async (token,data ) =>{
  try{
    const response = await axios.post("/check_pay_major_id",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const checkReceivableMajorID = async (token,data ) =>{
  try{
    const response = await axios.post("/check_rec_major_id",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const addReceivableMajorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/add_rec_major_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const addPayableMajorHead = async (token,data ) =>{
  try{
    const response = await axios.post("/add_pay_major_head",data,{
      headers:{
        Authorization: `Bearer ${token}`
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const uploadResolution = async (token,data) =>{
  try{
    const response = await axios.post("/upload_resolution",data,{
      headers:{
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const sendOTP = async (token,data) =>{
  try{
    const response = await axios.post("/send_otp_phone_number",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const ProcessTransaction = async (token,data) =>{
  try{
    const response = await axios.post("/verify_otp_and_release_vendor_payment",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const LegderPRI = async (token,data) =>{
  try{
    const response = await axios.post("/get_ledger_for_pri",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getOpeningBalance = async (token,data) =>{
  try{
    const response = await axios.post("/get_opening_balance",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
export const getVendorLedgerDetails = async (token,data) =>{
  try{
    const response = await axios.post("/get_ledger_for_vendor",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getDeductedTax = async (token,data) =>{
  try{
    const response = await axios.post("/get_all_deducted_taxes",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getBankName = async (token) =>{
  try{
    const response = await axios.get("/get_bank_names",{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getAllVendorAvailable = async (token,data) =>{
  try{
    const response = await axios.post("/get_all_vendor_available",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}

export const getVendorLedger = async (token,data) =>{
  try{
    const response = await axios.post("/get_ledger_for_vendor",data,{
      headers:{
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch(error){
    console.error("Error - ", error);
    throw error;
  }
}
 
export const getVendorLegderPageCount = async (token,data)=>{
  try {
    const response = await axios.post("/get_ledger_for_vendor_page_count",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getLegderPageCount = async (token,data)=>{
  try {
    const response = await axios.post("/get_ledger_pri_page_count",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getVendorPaymentPageCount = async (token,data)=>{
  try {
    const response = await axios.post("/get_vendor_payment_page_count",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getAllVendorPageCount = async (token,data)=>{
  try {
    const response = await axios.post("/get_vendor_page_count",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getBankDetails = async (token,data)=>{
  try {
    const response = await axios.post("/get_branch_details",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getAddressFromPincode = async (token,data)=>{
  try {
    const response = await axios.post("/get_details_from_pincode",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
} 

export const getPaymentTrack = async (token,data)=>{
  try {
    const response = await axios.post("/track_payment",data,{
      headers:{
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error)
    throw error
  }
}
